/* LOUD: collage, ficha, bolsa y páginas. Conectado a Shopify (carro Ajax y checkout). */
(function(){
'use strict';
const CFG=window.LOUD_CFG||{};
const $=id=>document.getElementById(id);
const list=s=>(s||'').split(/[\s,]+/).map(x=>x.trim()).filter(Boolean);
const READY=list(CFG.ready), BIG=list(CFG.big), NOMAT=list(CFG.noMat);
/* ?v= obliga a bajar la versión actual de cada foto (evita copias viejas en caché) */
const asset=n=>(CFG.assets||'')+n+'?v=2';
/* precios de Shopify vienen en centavos */
const clp=c=>'$'+Math.round(c/100).toLocaleString('es-CL');

/* datos de las fotos sin fondo (loud-data.js): R alto/ancho, X vistas extra, RANK orden por ventas al crear el tema */
const D=window.LOUD_DATA||{};
const R=D.R||{}, X=D.X||{}, RANK_SNAPSHOT=D.RANK||[];
/* productos fijados al principio del collage (Halloween) */
const PIN=D.PIN||['polera-loud-17-ghost-face','polera-loud-17-jason'];

function el(tag,props,kids){const e=document.createElement(tag);Object.assign(e,props||{});(kids||[]).forEach(k=>e.append(k));return e}
function rng(seed){return function(){seed|=0;seed=seed+0x6D2B79F5|0;let t=Math.imul(seed^seed>>>15,1|seed);t=t+Math.imul(t^t>>>7,61|t)^t;return((t^t>>>14)>>>0)/4294967296}}
function cat(h){
  if(h.startsWith('jogger')||h.startsWith('buzo')) return 'pant';
  if(h.startsWith('conjunto')) return 'set';
  if(h.startsWith('poleron')||h.startsWith('loud-track')) return 'hood';
  if(h.startsWith('polera')) return 'tee';
  return 'acc';
}
const ss={get:k=>{try{return sessionStorage.getItem(k)}catch(e){return null}},set:(k,v)=>{try{sessionStorage.setItem(k,v)}catch(e){}}};

/* ---------------- Collage ---------------- */
const stage=$('stage');
/* zoom por niveles: 0 normal, 1 más grande; en móvil hay un nivel 2 = un producto por fila */
let zoom=parseInt(ss.get('loud-zoom')||'0',10)||0;
const baseCols=W=>W<560?3:(W<900?4:(W<1200?5:6));
const maxZoom=()=>{const W=stage?stage.clientWidth:innerWidth;return W<560?2:1};
let ITEMS=[], RANK=RANK_SNAPSHOT;
function layout(){
  if(!stage) return;
  const W=stage.clientWidth; if(!W) return;
  zoom=Math.min(zoom,maxZoom());
  const r=rng(420);
  const rk=h=>{const f=PIN.indexOf(h);if(f>=0)return f-1000;const i=RANK.indexOf(h);return i<0?9999:i};
  const order=ITEMS.slice().sort((a,b)=>rk(a.h)-rk(b.h));
  const cols=Math.max(1,baseCols(W)-zoom);
  const cell=W/cols, S=cell*(cols===1?.82:.78);
  const items=order.map((p,i)=>{
    const q=R[p.h]||(p.r?1/p.r:1);
    const k=cols===1?1:(BIG.includes(p.h)?1.24:.92+r()*.2), Sk=S*k;
    const w=q>=1?Sk/q:Sk, hh=q>=1?Sk:Sk*q;
    const c=i%cols, row=Math.floor(i/cols);
    const jx=(r()-.5)*cell*.2, jy=(r()-.5)*cell*.22;
    const rot=(r()<.5?-1:1)*(1+r()*(cols===1?2.5:5)), rad=Math.abs(rot)*Math.PI/180;
    const bw=(w*Math.cos(rad)+hh*Math.sin(rad))*1.07, pad=(bw-w)/2+6;
    const x=Math.min(Math.max(c*cell+(cell-w)/2+jx,pad),W-w-pad);
    const y=row*cell*.98+(cell-hh)/2+jy+(c%2?cell*.08:0);
    return {p,w,hh,x,y,rot,z:1+Math.floor(r()*60)};
  });
  stage.textContent='';
  items.forEach((it,i)=>{
    const a=el('a',{className:'it',href:it.p.u});
    a.setAttribute('aria-label',it.p.t);
    const img=el('img',{alt:'',decoding:'async',src:R[it.p.h]?asset('c-'+it.p.h+'.webp'):(it.p.i||'')});
    if(i>18) img.loading='lazy';
    a.append(img);
    a.style.cssText='left:'+it.x+'px;top:'+it.y+'px;width:'+it.w+'px;height:'+it.hh+'px;transform:rotate('+it.rot.toFixed(1)+'deg);z-index:'+it.z;
    a.style.setProperty('--r',it.rot.toFixed(1)+'deg');
    a.addEventListener('click',()=>ss.set('loud-y',String(scrollY)));
    stage.append(a);
  });
  const bottom=items.length?Math.max(...items.map(i=>i.y+i.hh)):0;
  stage.style.height=(bottom+40)+'px';
}
if(stage){
  try{ITEMS=JSON.parse($('loud-products').textContent)}catch(e){ITEMS=[]}
  layout();
  /* volver desde una ficha: mismo punto del collage */
  const y=ss.get('loud-y');
  if(y&&performance.getEntriesByType&&(performance.getEntriesByType('navigation')[0]||{}).type==='back_forward') scrollTo(0,+y);
  /* orden vivo por más vendidos */
  const coll=stage.dataset.collection||'all';
  fetch(CFG.root.replace(/\/$/,'')+'/collections/'+coll+'?sort_by=best-selling&view=loud-rank',{credentials:'same-origin'})
    .then(r=>r.ok?r.json():null).then(l=>{if(Array.isArray(l)&&l.length){RANK=l;layout()}}).catch(()=>{});
  const zb=$('zoom');
  /* "+" mientras se pueda acercar más; flecha de volver en el nivel máximo */
  const syncZoom=()=>{const top=zoom>=maxZoom();$('zPlus').hidden=top;$('zBack').hidden=!top;zb.setAttribute('aria-pressed',String(zoom>0));zb.setAttribute('aria-label',top?'Volver a la vista normal':'Ver productos más grandes')};
  syncZoom();
  let lastW=stage.clientWidth,tm;
  addEventListener('resize',()=>{clearTimeout(tm);tm=setTimeout(()=>{if(stage.clientWidth&&stage.clientWidth!==lastW){lastW=stage.clientWidth;layout();syncZoom()}},120)});
  zb.addEventListener('click',()=>{
    const f=scrollY/Math.max(1,document.documentElement.scrollHeight);
    zoom=zoom>=maxZoom()?0:zoom+1;ss.set('loud-zoom',String(zoom));layout();syncZoom();
    scrollTo(0,f*document.documentElement.scrollHeight);
  });
}

/* ---------------- Ficha de producto ---------------- */
let PROD=null;
try{PROD=JSON.parse(($('loud-product')||{}).textContent||'null')}catch(e){PROD=null}
if(PROD){
  const h=PROD.h;
  $('pp').textContent=clp(+$('pp').dataset.cents);
  /* fotos: recortes del tema si existen; si no, las fotos de Shopify */
  let shots;
  if(R[h]) shots=[[asset('b-'+h+'.webp'),'cut']].concat((X[h]||[]).map(([n,k])=>[asset('x-'+n+'.webp'),k]));
  else shots=(PROD.img.length?PROD.img:['']).map(u=>[u,'cut']);
  let idx=0;
  const dots=$('dots');
  const show=i=>{
    idx=(i+shots.length)%shots.length;
    const [src,k]=shots[idx];
    $('frame').className='frame ready '+k;
    const img=$('shot');img.removeAttribute('width');img.removeAttribute('height');img.src=src;img.alt=idx?PROD.t+', vista '+(idx+1)+' de '+shots.length:PROD.t;
    dots.querySelectorAll('.dot').forEach((b,j)=>b.setAttribute('aria-current',j===idx?'true':'false'));
    if(shots[idx+1]) new Image().src=shots[idx+1][0];
  };
  if(shots.length>1){
    $('prev').hidden=false;$('next').hidden=false;
    shots.forEach((s,j)=>{const b=el('button',{type:'button',className:'dot'});b.setAttribute('aria-label','Foto '+(j+1));b.onclick=()=>show(j);dots.append(b)});
    $('prev').onclick=()=>show(idx-1);$('next').onclick=()=>show(idx+1);
    addEventListener('keydown',e=>{if(/input|textarea/i.test(e.target.tagName)||!$('cart').hidden)return;if(e.key==='ArrowLeft')show(idx-1);else if(e.key==='ArrowRight')show(idx+1)});
    let sx=null;
    $('frame').addEventListener('pointerdown',e=>{sx=e.clientX});
    $('frame').addEventListener('pointerup',e=>{if(sx===null)return;const dx=e.clientX-sx;sx=null;if(Math.abs(dx)>40)show(idx+(dx<0?1:-1))});
  }
  show(0);

  /* INFO: listos para envío, composición, cuidados */
  const wear=cat(h)!=='acc', ready=READY.includes(h);
  $('ready').hidden=!ready;$('mto').hidden=ready;
  $('mat').hidden=!wear||NOMAT.includes(h);$('fit').hidden=!wear;$('careh').hidden=!wear;$('care').hidden=!wear;

  const toggle=(btn,panel)=>{const open=panel.hidden;panel.hidden=!open;btn.setAttribute('aria-expanded',String(open))};
  $('info').onclick=()=>toggle($('info'),$('note'));
  $('store').onclick=()=>toggle($('store'),$('storeCard'));
  document.querySelectorAll('.close').forEach(x=>x.onclick=()=>{const b=$(x.dataset.for);b.setAttribute('aria-expanded','false');$(b.getAttribute('aria-controls')).hidden=true;b.focus()});

  /* + y tallas */
  const plus=$('plus'),sizes=$('sizes');
  const addVariant=id=>{
    sizes.hidden=true;plus.setAttribute('aria-expanded','false');
    fetch(CFG.root.replace(/\/$/,'')+'/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:+id,quantity:1}]})})
      .then(r=>r.ok?r.json():r.json().then(e=>Promise.reject(e)))
      .then(()=>{$('msg').textContent='Añadido al carrito';openCart()})
      .catch(e=>{$('msg').textContent=(e&&e.description)||'No pudimos agregarlo. Inténtalo de nuevo.'});
  };
  if(PROD.a&&!plus.disabled){
    plus.onclick=()=>{
      if(PROD.single){addVariant(PROD.v[0].id);return}
      const open=sizes.hidden;sizes.hidden=!open;plus.setAttribute('aria-expanded',String(open));$('msg').textContent='';
      if(open) sizes.querySelector('.sz:not(:disabled)')?.focus();
    };
    sizes.querySelectorAll('.sz').forEach(b=>b.onclick=()=>addVariant(b.dataset.id));
  }
}

/* ---------------- Barra: volver ---------------- */
const back=$('back');
back.addEventListener('click',e=>{
  if(panelOpen()){e.preventDefault();closePanel();return}
  if(PROD){
    try{
      if(document.referrer&&new URL(document.referrer).origin===location.origin&&history.length>1){e.preventDefault();history.back()}
    }catch(err){}
  }
});

/* ---------------- Contacto, Envíos, Cambios (#contacto, #envios, #cambios) ---------------- */
const PANELS={contacto:'contact',envios:'envios',cambios:'cambios'};
const main=$('main'), foot=$('foot');
const isHome=!!stage;
function panelOpen(){return !!PANELS[location.hash.slice(1)]}
function closePanel(){history.pushState('',document.title,location.pathname+location.search);route()}
function route(){
  const p=PANELS[location.hash.slice(1)];
  Object.values(PANELS).forEach(id=>$(id).hidden=id!==p);
  main.hidden=!!p;
  foot.hidden=!(p||isHome);
  if(isHome){$('zoom').hidden=!!p;back.hidden=!p}
  if(p) scrollTo(0,0);
}
addEventListener('hashchange',route);
addEventListener('popstate',route);
/* formulario enviado: Shopify vuelve con ?contact_posted=true */
if(/contact_posted=true/.test(location.search)||($('fstat')&&$('fstat').textContent.trim())){
  if(location.hash.slice(1)!=='contacto') history.replaceState('',document.title,location.pathname+location.search+'#contacto');
}
route();

const cform=$('cform');
if(cform){
  const req=['fname','fmail','fmsg'];
  cform.addEventListener('submit',e=>{
    let first=null;
    req.forEach(id=>{const i=$(id),v=i.value.trim(),ok=v&&(id!=='fmail'||/^\S+@\S+\.\S+$/.test(v));i.setAttribute('aria-invalid',String(!ok));if(!ok&&!first)first=i});
    if(first){e.preventDefault();$('fstat').textContent=first.id==='fmail'&&first.value?'Revisa tu correo, parece incompleto.':'Completa nombre, correo y mensaje.';first.focus()}
  });
  req.forEach(id=>$(id).addEventListener('input',e=>e.target.removeAttribute('aria-invalid')));
}

/* ---------------- Bolsa (carro de Shopify) ---------------- */
const cart=$('cart'),shade=$('shade');
let CART=null,lastFocus=null,busy=false;
function api(path,body){
  return fetch(CFG.root.replace(/\/$/,'')+path,body?{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)}:{credentials:'same-origin',headers:{'Accept':'application/json'}})
    .then(r=>r.ok?r.json():r.json().then(e=>Promise.reject(e)));
}
/* regalo: con el primer producto se agrega el regalo (gratis por el descuento automático de Shopify); si no queda nada más, se quita */
/* promoción hasta el domingo 25-10-2026 a las 23:59 (Chile) */
const GIFT_END=Date.parse('2026-10-26T03:00:00Z');
const isGift=l=>!!(l.properties&&l.properties._regalo);
function syncGift(c){
  if(!CFG.gift||!c) return Promise.resolve(c);
  const paid=c.items.filter(l=>!isGift(l)), gift=c.items.find(isGift), expired=Date.now()>=GIFT_END;
  if(gift&&(expired||!paid.length)) return api('/cart/change.js',{id:gift.key,quantity:0}).catch(()=>c);
  if(expired) return Promise.resolve(c);
  if(paid.length&&!gift) return api('/cart/add.js',{items:[{id:CFG.gift,quantity:1,properties:{_regalo:'1'}}]}).then(()=>api('/cart.js')).catch(()=>c);
  if(gift&&gift.quantity>1) return api('/cart/change.js',{id:gift.key,quantity:1}).catch(()=>c);
  return Promise.resolve(c);
}
function syncCount(n){
  const c=$('count');c.textContent=n;c.hidden=!n;
  $('bag').setAttribute('aria-label','Bolsa, '+n+(n===1?' producto':' productos'));
}
function renderCart(){
  if(!CART) return;
  const n=CART.item_count;syncCount(n);
  $('ctitle').textContent='Bolsa ('+n+')';
  const ul=$('lines');ul.textContent='';
  $('empty').hidden=!!n;ul.hidden=!n;$('cfoot').hidden=!n;
  CART.items.forEach(l=>{
    const set=q=>{if(busy)return;busy=true;api('/cart/change.js',{id:l.key,quantity:q}).then(syncGift).then(c=>{CART=c;renderCart()}).catch(e=>{$('paymsg').textContent=(e&&e.description)||'No pudimos actualizar la bolsa.'}).finally(()=>{busy=false})};
    if(isGift(l)){
      const src=R[l.handle]?asset('c-'+l.handle+'.webp'):(l.image||'');
      ul.append(el('li',{className:'giftline'},[
        el('span',{className:'th'},[el('img',{src,alt:l.product_title})]),
        el('div',{},[el('p',{className:'nm',textContent:l.product_title}),el('p',{className:'sz2',textContent:'Regalo · Incluido en tu pedido'})]),
        el('div',{className:'lp'},[el('span',{textContent:'Gratis'})])
      ]));
      return;
    }
    const minus=el('button',{type:'button',textContent:'−'});minus.setAttribute('aria-label','Quitar una unidad');minus.onclick=()=>set(l.quantity-1);
    const add=el('button',{type:'button',textContent:'+'});add.setAttribute('aria-label','Sumar una unidad');add.onclick=()=>set(l.quantity+1);
    const rm=el('button',{type:'button',className:'rm',textContent:'Quitar'});rm.onclick=()=>{set(0);$('cclose').focus()};
    const size=l.product_has_only_default_variant?'Talla única':'Talla '+(l.variant_title||'');
    const src=R[l.handle]?asset('c-'+l.handle+'.webp'):(l.image||'');
    ul.append(el('li',{},[
      el('a',{className:'th',href:l.url},[el('img',{src,alt:l.product_title})]),
      el('div',{},[el('p',{className:'nm',textContent:l.product_title}),el('p',{className:'sz2',textContent:size}),el('div',{className:'qty'},[minus,el('span',{textContent:l.quantity}),add])]),
      el('div',{className:'lp'},[el('span',{textContent:clp(l.final_line_price)}),rm])
    ]));
  });
  $('subt').textContent=clp(CART.items_subtotal_price!=null?CART.items_subtotal_price:CART.total_price);
  $('paymsg').textContent='';
}
function loadCart(){return api('/cart.js').then(syncGift).then(c=>{CART=c;renderCart();return c})}
function openCart(){
  lastFocus=document.activeElement;
  cart.hidden=false;shade.hidden=false;
  requestAnimationFrame(()=>{cart.classList.add('on');shade.classList.add('on')});
  document.body.style.overflow='hidden';$('cclose').focus();
  loadCart().catch(()=>{});
}
function closeCart(){
  cart.classList.remove('on');shade.classList.remove('on');document.body.style.overflow='';
  setTimeout(()=>{cart.hidden=true;shade.hidden=true},300);
  if(lastFocus&&document.contains(lastFocus)) lastFocus.focus();
}
$('bag').onclick=openCart;$('cclose').onclick=closeCart;shade.onclick=closeCart;
addEventListener('keydown',e=>{if(e.key==='Escape'&&!cart.hidden)closeCart()});

/* código promocional: se lleva al pago y Shopify lo valida */
let code=ss.get('loud-code')||'';
$('promoBtn').onclick=()=>{const f=$('promo'),open=f.hidden;f.hidden=!open;$('promoBtn').setAttribute('aria-expanded',String(open));if(open){$('pcode').value=code;$('pcode').focus()}};
$('promo').addEventListener('submit',e=>{
  e.preventDefault();
  const c=$('pcode').value.trim().toUpperCase(),m=$('pmsg');m.hidden=false;
  if(!c){m.textContent='Escribe un código para aplicarlo.';$('pcode').focus();return}
  code=c;ss.set('loud-code',c);
  m.textContent='Código '+c+' guardado. El descuento se aplica en el método de pago.';
});
$('pay').onclick=()=>{
  location.href=CFG.root.replace(/\/$/,'')+'/checkout'+(code?'?discount='+encodeURIComponent(code):'');
};

/* en /cart se abre la bolsa directamente */
if(CFG.template==='cart') openCart();
})();